import { Category } from '../entities/interface';

export const DEFAULT_CATEGORY: Category = {
  id: 0,
  name: 'ALL CATEGORIES',
};
